import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: EASE }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const Chapter = ({ index, label, dark = false }) => (
    <p
        className={`text-[11px] font-medium tracking-[0.28em] uppercase ${
            dark ? "text-[#899B6A]" : "text-[#899B6A]"
        }`}
    >
        {index} — {label}
    </p>
);
